import * as React from "react";
import { AdvancedSearchInputFactoryHelper } from "../../classifier/InputFactory";
import { IAllInputProps } from "../../../../../interfaces/advancedSearch/IAllInputProps";
import { InputEnum } from "../../../../enums/NormalInputTypeEnum";

export interface IInputCreator {
  type: InputEnum;
  info: IAllInputProps;
}

export const InputCreator: React.FunctionComponent<IInputCreator> = props => {
  React.useEffect(() => {
    switch (props.type) {
      case InputEnum.Percentage:
        props.info.handleValueChange(props.info.searchInputData?.index, props.info.searchInputData?.value ? props.info.searchInputData.value * 100 : null);
        break;
      case InputEnum.Date:
        props.info.handleValueChange(props.info.searchInputData?.index, null);
        break;
    }
  }, []);

  return AdvancedSearchInputFactoryHelper.createInput(props.type, props.info);
};

export default InputCreator;
